import Grid, { type GridProps, type GridSize } from '@commons/containers/Grid';
import PageBuilder from '@commons/pagebuilder';

import type { DrupalPressReleaseView } from '.';
import styles from './Cards.module.scss';

/**
 * Cards display of the Press Release view.
 *
 * Renders a set of insights as cards.
 * On mobile, the content overflows to the right.
 */

const CardsDisplay = ({ content, settings }: DrupalPressReleaseView) => {
  const limit = settings.limit ? parseInt(settings.limit, 10) : 3;

  const columns: GridProps['columns'] = (limit >= 3 ? 3 : limit) as GridSize;

  return (
    <Grid gap="md" columns={columns} className={styles.wrapper}>
      {content.map(PageBuilder.renderNode)}
    </Grid>
  );
};

export default CardsDisplay;
